export default __webpack_public_path__ + "static/media/snd_00009.43650909.mp4";